module.exports = __webpack_public_path__ + "img/chatbg.ce0e7865.png";